import { ArrowUpRight, ArrowRight } from 'lucide-react';
import { Reveal, SectionLabel } from '../components/Common';
import { ScrollCard } from '../components/ScrollCard';
import { f3dHero, f3dHeroImage, f3dRealizzazioni, f3dProcess, f3dFinal } from '../fantasti3dData';
import '../styles/fantasti3d.css';

export const Fantasti3D = () => <main id="content" className="f3d-page">
  <section className="f3d-hero section-pad" data-testid="fantasti3d-hero">
    <SectionLabel number="03" id="fantasti3d">{f3dHero.label}</SectionLabel>
    <div className="f3d-hero-grid">
      <Reveal className="f3d-hero-copy">
        <h1 className="display-heading f3d-hero-title" data-testid="fantasti3d-title"><span>{f3dHero.titleA}</span><em>{f3dHero.titleB}</em></h1>
        <span className="eyebrow f3d-hero-sub" data-testid="fantasti3d-subtitle">{f3dHero.subtitle}</span>
        <h2 className="f3d-hero-headline">{f3dHero.headline}</h2>
        <p className="f3d-hero-text" data-testid="fantasti3d-hero-text">{f3dHero.text}</p>
        <a href="/#scrivici" className="button button-gold f3d-hero-cta" data-testid="fantasti3d-hero-cta">{f3dHero.cta} <ArrowUpRight size={19} /></a>
      </Reveal>
      <ScrollCard className="f3d-hero-media" index={1}>
        <img src={f3dHeroImage} alt="Stampante 3D di grande formato che realizza un enorme mascherone di Carnevale, con layer di stampa visibili" />
      </ScrollCard>
    </div>
  </section>

  <section className="f3d-realizzazioni" data-testid="fantasti3d-realizzazioni">
    <SectionLabel number="04" id="realizzazioni">LE NOSTRE REALIZZAZIONI</SectionLabel>
    <div className="f3d-cards">
      {f3dRealizzazioni.map((item, i) => <ScrollCard key={item.id} index={i}>
        <a href="/#scrivici" className="f3d-card" data-testid={`fantasti3d-card-${item.id}`} aria-label={`Contattaci per ${item.label}`}>
          <div className="f3d-card-photo"><img src={item.image} alt={item.label} loading="lazy" /></div>
          <div className="f3d-card-body">
            <div className="f3d-card-head"><h3 className="f3d-card-title">{item.label}</h3><ArrowRight size={22} strokeWidth={1.6} /></div>
            <p className="f3d-card-text">{item.text}</p>
          </div>
        </a>
      </ScrollCard>)}
    </div>
  </section>

  <section className="f3d-process section-pad" data-testid="fantasti3d-process">
    <SectionLabel number="05" id="processo">IL NOSTRO PROCESSO</SectionLabel>
    <div className="f3d-steps">
      {f3dProcess.map((step, i) => <ScrollCard key={step.n} index={i}>
        <div className="f3d-step" data-testid={`fantasti3d-step-${step.n}`}>
          <div className="f3d-step-photo"><img src={step.image} alt={step.title} loading="lazy" /></div>
          <div className="f3d-step-head"><span className="f3d-step-num">{step.n}</span><h3 className="f3d-step-title">{step.title}</h3></div>
          <p className="f3d-step-text">{step.text}</p>
        </div>
      </ScrollCard>)}
    </div>
  </section>

  <section className="f3d-final section-pad" data-testid="fantasti3d-final">
    <div className="f3d-final-grid">
      <Reveal><h2 className="display-heading f3d-final-title">{f3dFinal.titleA}<br /><em>{f3dFinal.titleB}</em></h2></Reveal>
      <Reveal className="f3d-final-aside" delay={0.1}>
        <p className="f3d-final-text">{f3dFinal.text}</p>
        <a href="/#scrivici" className="button button-gold f3d-final-cta" data-testid="fantasti3d-final-cta">{f3dFinal.cta} <ArrowUpRight size={19} /></a>
      </Reveal>
    </div>
  </section>
</main>;
